import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

const LiquidationRequestedContract = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable
          title="Danh sách hợp đồng chờ thanh lý"
          name="LiquidationRequestedContract"
          disableAdd
          whereQuery={{
            liquidationRequestedAt: {
              $exists: true,
            },
            status: {
              $ne: "completed",
            },
          }}
        />
      </Container>
    </div>
  );
};

export default LiquidationRequestedContract;
